import { api } from '../createApi';
import { TagType } from '../TagType';

const TAG_BY_LIST = { type: TagType.Guidelines, id: 'LIST' };
const TAG_BY_LIST_PLAYBOOKS = { type: TagType.Playbooks, id: 'LIST' };

api.enhanceEndpoints({
  addTagTypes: [TagType.Guidelines as TagType],
  endpoints: {
    getGuidelines: {
      providesTags: [TAG_BY_LIST],
    },
    getGuideline: {
      providesTags: (_result, _error, guidelineId) => [
        { type: TagType.Guidelines, id: guidelineId },
      ],
    },
    createGuideline: {
      invalidatesTags: [TAG_BY_LIST],
    },
    updateGuideline: {
      invalidatesTags: (_result, _error, arg) => [
        { type: TagType.Guidelines, id: arg.uuid },
        TAG_BY_LIST,
        TAG_BY_LIST_PLAYBOOKS,
      ],
    },
    deleteGuideline: {
      invalidatesTags: (_result, _error, arg) => [
        { type: TagType.Guidelines, id: arg.guidelineId },
        TAG_BY_LIST,
        TAG_BY_LIST_PLAYBOOKS,
      ],
    },
  },
});
